"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemorySpaceProvider = exports.SharedWorkerArbitratorClient = void 0;
exports.FatSharedWorkerSetup = FatSharedWorkerSetup;
const worker_consensus_1 = require("@branch-ts/worker-consensus");
const Leaf = __importStar(require("leaf-ts"));
require("with-caution");
const puri_1 = require("@branch-ts/puri");
let SharedWorkerArbitratorClient = (() => {
    let _instanceExtraInitializers = [];
    let _connect_decorators;
    return class SharedWorkerArbitratorClient {
        constructor() {
            this.situations = (__runInitializers(this, _instanceExtraInitializers), new Leaf.Situations({
                connected: false
            }));
            this.rpc = new Leaf.RPCComposer();
            this.getTrailResource = this.rpc.createRPCInvokeInterface({ name: "getTrailResource" });
            this.getArbitratorAccessProvider = this.rpc.createRPCInvokeInterface({
                name: "getArbitratorAccessProvider"
            });
            this.arbitratorAccessProvider = null;
            this.worker = null;
            this.connection = null;
        }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            _connect_decorators = [Leaf.lock()];
            __esDecorate(this, null, _connect_decorators, { kind: "method", name: "connect", static: false, private: false, access: { has: obj => "connect" in obj, get: obj => obj.connect }, metadata: _metadata }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(this, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        }
        async connect(option) {
            if (this.rpc.isOpen()) {
                this.situations.set("connected", true);
                return;
            }
            let jsUrl = option.jsUrl;
            if (option.version !== undefined) {
                if (!option.version.trim())
                    throw new Error("Worker version must not be empty");
                const url = new URL(jsUrl, document.baseURI);
                url.searchParams.set("version", option.version);
                jsUrl = url.href;
            }
            const connectResult = await worker_consensus_1.SharedWorkerRPCCenterMechanism.connectFromClient({
                jsUrl,
                name: option.name,
                type: option.type,
                credentials: option.credentials,
            });
            const worker = connectResult.worker;
            const connection = connectResult.connection;
            this.worker = worker;
            this.connection = connection;
            this.rpc.setConnection(connection);
            connection.events.on("close", () => {
                this.situations.set("connected", false);
            });
            await this.rpc.remoteEvents.wait("ready");
            this.situations.set("connected", true);
            const [res, reason] = await this.getArbitratorAccessProvider({});
            if (reason) {
                throw new Error(`Failed to get arbitrator access provider: ${reason}`);
            }
            const browserSessionVendor = "BrowserSession";
            this.arbitratorAccessProvider = res.provider;
            this.idpsSpace = new InMemorySpaceProvider({
                protocol: "idps",
                kind: "idp",
                vendor: browserSessionVendor,
                arbitratorAccessProvider: this.arbitratorAccessProvider,
            });
        }
        close() {
            const connection = this.connection;
            if (!connection)
                return;
            connection.close();
        }
        getWorker() {
            return this.worker;
        }
        getConnection() {
            return this.connection;
        }
    };
})();
exports.SharedWorkerArbitratorClient = SharedWorkerArbitratorClient;
function FatSharedWorkerSetup(config) {
    const sharedWorkerClient = new SharedWorkerArbitratorClient();
    const self = {
        sharedWorkerClient,
        getConnection: () => sharedWorkerClient.getConnection(),
        getWorker: () => sharedWorkerClient.getWorker(),
        close: () => sharedWorkerClient.close(),
        setup: async (input) => {
            void input;
            await sharedWorkerClient.connect({
                jsUrl: config.jsUrl,
                version: config.version,
                name: config.name,
                type: config.type,
                credentials: config.credentials,
            });
            return self;
        },
    };
    return self;
}
class InMemorySpaceProvider extends puri_1.StaticSpaceProvider {
    constructor(option) {
        super(option);
        this.arbitratorAccessProvider = option.arbitratorAccessProvider;
    }
    async create(option) {
        const [res, reason, ...errors] = await this.arbitratorAccessProvider.create({
            vendor: this.vendor,
            kindSpec: `${this.kind}+${this.protocol}`,
            input: option.data,
            annotation: null,
        });
        if (reason) {
            return [, reason, ...errors];
        }
        this.items.push({
            uri: res.uri,
            data: option.data,
        });
        return [{
                uri: res.uri,
                data: option.data,
            }];
    }
}
exports.InMemorySpaceProvider = InMemorySpaceProvider;
